export const normalizeInvoiceConfigResponse = (data: unknown) => {
  if (Array.isArray(data)) {
    const firstEvent = data[0];
    if (!firstEvent) return {};

    const configurations = data
      .flatMap((event: any) =>
        Array.isArray(event?.configurations)
          ? event.configurations
          : event?.configurations
            ? [event.configurations]
            : [],
      );

    return { ...firstEvent, configurations };
  }
  return data ?? {};
};

export const invoiceSessionMatchesConfiguration = (
  session: { Id?: unknown; _id?: unknown } | null | undefined,
  sessionIds: unknown[] = [],
) => {
  const configuredIds = new Set(sessionIds.map((id) => String(id)));
  return [session?.Id, session?._id]
    .filter(Boolean)
    .some((id) => configuredIds.has(String(id)));
};
